import Link from 'next/link';
import { FunctionComponent, useMemo } from 'react';
import Container from '../../../components/Container';
import Layout from '../../../layouts/Layout';
import styles from './styles.module.scss';

export type SitemapPageProps = {
    title: string;
    pageDescription: string;
    currentPage: number;
    totalPages: number;
    pages: Array<{ title: string; url: string }>;
};

export const SitemapPage: FunctionComponent<SitemapPageProps> = ({
    title,
    pageDescription,
    currentPage,
    totalPages,
    pages,
}) => {
    const pagesRange = useMemo(() => {
        return new Array(totalPages).fill(null).map((_, index) => {
            return index + 1;
        });
    }, [totalPages]);

    return (
        <Layout title={`${title} - Cademy`} description={pageDescription}>
            <Container className={styles.container}>
                <nav className={styles.headerNav}>
                    <ul>
                        <li>
                            <Link href={`../locations/1`} aria-current={title === 'Locations'}>
                                Locations
                            </Link>
                        </li>
                        <li>
                            <Link
                                href={`../popular-searches/1`}
                                aria-current={title === 'Popular Searches'}
                            >
                                Popular Searches
                            </Link>
                        </li>
                        <li>
                            <Link
                                href={`../popular-location-searches/1`}
                                aria-current={title === 'Popular Searches by Location'}
                            >
                                Popular searches by location
                            </Link>
                        </li>
                        <li>
                            <Link href={`../educators/1`} aria-current={title === 'Educators'}>
                                Educators
                            </Link>
                        </li>
                    </ul>
                </nav>
                <h1>{title}</h1>
                <ul className={styles.pageList}>
                    {pages.map((page) => {
                        return (
                            <li key={page.url}>
                                <Link href={page.url} prefetch={false}>
                                    {page.title}
                                </Link>
                            </li>
                        );
                    })}
                </ul>
                {totalPages > 1 ? (
                    <>
                        <h1>More {title}</h1>
                        <nav aria-label="Pagination Navigation" className={styles.pagination}>
                            <ol>
                                {pagesRange.map((page) => {
                                    const isCurrentPage = page === currentPage;
                                    const label = isCurrentPage
                                        ? `Current Page, Page ${page}`
                                        : `Goto Page ${page}`;
                                    return (
                                        <li key={page}>
                                            <Link
                                                href={`./${page}`}
                                                aria-label={label}
                                                aria-current={isCurrentPage}
                                            >
                                                {page}
                                            </Link>
                                        </li>
                                    );
                                })}
                            </ol>
                        </nav>
                    </>
                ) : null}
            </Container>
        </Layout>
    );
};
